import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { MdbModalModule, MdbModalRef } from 'src/lib/mdb5-adapted/public-api';

import { LmsModalFrameComponent } from '@lmsSharedUI';

import { SpinnerModel } from '../../loaders/spinner/spinner.model';

@Component({
  selector: 'app-session-expired',
  standalone: true, // Mark the component as standalone
  imports: [CommonModule, MdbModalModule, LmsModalFrameComponent], // Import required Angular modules here
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class SessionExpiredComponent implements OnInit, OnDestroy {
  title: string;
  message: string;
  display: any;
  showMessage: boolean;
  spinnerModel: SpinnerModel;
  login: boolean = false;

  constructor(
    public dialogRef: MdbModalRef<SessionExpiredComponent>
  ) {
    this.title ||= "This session will expire in:";
    this.timer(1);
  }

  timerInstance: any = null;

  timer(minute: number) {
    console.log("Starting countdown for", minute, "minute(s)");


    this.clearTimers();

    let seconds: number = minute * 60;
    let textSec: string = "00";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";

    this.timerInstance = setInterval(() => {
      seconds--;
      statSec = statSec !== 0 ? statSec - 1 : 59;
      textSec = statSec < 10 ? "0" + statSec : statSec.toString();

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds === 0) {
        this.title = "Session Expired!";
        clearInterval(this.timerInstance);
        this.showMessage = true;
      }
    }, 1000);
  }


  clearTimers() {
    if (this.timerInstance) {
      clearInterval(this.timerInstance);
      this.timerInstance = null;
    }
  }


  onConfirm(): void {
    this.showMessage = false;
    this.clearTimers();
    this.dialogRef.close(true);
    //this.timer(2);
  }


  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.clearTimers();
  }
}


